import { render } from "./PlayerBar.vue?vue&type=template&id=01d83ce7"
import script from "./PlayerBar.vue?vue&type=script&lang=js"
export * from "./PlayerBar.vue?vue&type=script&lang=js"

import "./PlayerBar.vue?vue&type=style&index=0&id=01d83ce7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__